import React from "react";
import Todo from "./components/Todo";
import "./index.css";

function App() {
  return <Todo />;
}

export default App;
